import React, { useState } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { getProfileById } from '../lib/supabase';
import { LogOut, User } from 'lucide-react';

interface UserPanelProps {
  session: any;
  onSignOut: () => void;
}

export function UserPanel({ session, onSignOut }: UserPanelProps) {
  const [profile, setProfile] = useState<any>(null);

  React.useEffect(() => {
    if (session?.user) {
      fetchProfile();
    }
  }, [session]);

  const fetchProfile = async () => {
    if (!session?.user?.id) return;
    
    const { data, error } = await getProfileById(session.user.id);
    if (!error && data) {
      setProfile(data);
    }
  };

  return (
    <Menu as="div" className="relative">
      <Menu.Button className="w-12 h-12 rounded-2xl flex items-center justify-center hover:bg-custom-orange-50 transition-all group relative">
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-custom-orange-300 to-custom-orange-400 flex items-center justify-center text-white text-sm">
          {profile?.username?.[0]?.toUpperCase() || <User size={16} />}
        </div>
        <span className="absolute left-full ml-2 px-2 py-1 bg-white rounded-lg shadow-lg text-sm whitespace-nowrap opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity">
          Profile
        </span>
      </Menu.Button>

      <Transition
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <Menu.Items className="absolute left-full ml-2 bottom-0 w-48 bg-white rounded-xl shadow-lg py-2">
          <div className="px-4 py-2 border-b border-gray-100">
            <div className="font-medium text-gray-700">{profile?.username}</div>
            <div className="text-sm text-gray-500">{session?.user?.email}</div>
          </div>
          <Menu.Item>
            {({ active }) => (
              <button
                onClick={onSignOut}
                className={`${
                  active ? 'bg-red-50 text-red-500' : 'text-gray-700'
                } group flex w-full items-center gap-2 px-4 py-2 text-sm`}
              >
                <LogOut size={18} />
                Sign Out
              </button>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}